import { BrandMark } from '../../components/BrandMark';
import { Headline } from '../../components/Headline';
import styles from './SignInPage.module.css';

const PROOF = [
  ['42', 'DAY FITNESS'],
  ['7', 'DAY FATIGUE'],
  ['1', 'NUMBER THAT MATTERS: FORM'],
] as const;

export function BrandPanel() {
  return (
    <section className={styles.brandSide} aria-label="About PainPal">
      <BrandMark tone="dark" />
      <div className={styles.hero}>
        <span className={styles.sticker}>NO PAYWALL ON YOUR OWN DATA</span>
        <Headline first="LOAD IN." second="FORM OUT." size="hero" />
      </div>
      <dl className={styles.proof}>
        {PROOF.map(([value, key]) => (
          <div key={key} className={styles.proofItem}>
            <dt className={styles.proofKey}>{key}</dt>
            <dd className={styles.proofValue}>{value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
